import { render } from "./CoiffeurCard.vue?vue&type=template&id=6b40c038"
import script from "./CoiffeurCard.vue?vue&type=script&lang=js"
export * from "./CoiffeurCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__